// JOBE-0044.14: Cedar-denied detect — soft heuristic per spec §Variant 5.
//
// The silent-drop posture (umbrella R10, ADR-0023 §D6) makes "you have
// no permits" and "this deployment has no entities yet" look identical
// on the wire — both return 200 with empty `items`. The soft tell is
// the entity-types fetch: if it has resolved successfully (`status ===
// 'ready'`) AND came back empty, the cause is almost certainly missing
// entity-type permits, not a deployment with no entities.
//
// Requires `entityTypesCtx.status === 'ready'` before evaluating the
// empty-types branch. A `loading` value (initial fetch in flight) must
// not be misread as Cedar-denied — that would fire on every cold start
// before the provider's fetch resolves. PR #677 review fix-up pinned
// this guard explicitly. An `error` value routes to the unreachable
// variant in `pickVariant`; this detect ignores it.

export function isCedarDenied({ entitiesItems, entityTypesCtx, removableChips }) {
  if (!entityTypesCtx || entityTypesCtx.status !== 'ready') return false;
  const items = Array.isArray(entitiesItems) ? entitiesItems : [];
  const types = Array.isArray(entityTypesCtx.types) ? entityTypesCtx.types : [];
  const chipCount = typeof removableChips === 'number' ? removableChips : 0;
  return items.length === 0
    && chipCount === 0
    && types.length === 0;
}
